// UTF-8

$(function(){
	$('.header_dd_menu').click(function(){
		$(this).toggleClass('header_dd_open header_dd_close').next().slideToggle();
	});
	// フッターのドロップダウン部分を2カラムに
	var footer_box = Math.ceil($('.footer-nav--has-dropdown .footer-nav__dropdown ul > li').length / 2);
	$('.footer-nav--has-dropdown .footer-nav__dropdown ul > li:lt(' + footer_box + ')').wrapAll('<div>');
	$('.footer-nav--has-dropdown .footer-nav__dropdown ul > li').wrapAll('<div>')
});
